import React, { Component } from 'react';
// TODO: should create proper 'validating' screen
export default class ValidatingView extends Component {
  render() {
    return (
      <div>Validating.. please wait</div>
    );
  }
}
